<script setup lang="ts">
import { useAttrs } from 'vue';
import { useFieldControlId } from './fieldContext';

defineOptions({ inheritAttrs: false });

withDefaults(
  defineProps<{
    placeholder?: string;
    rows?: number;
    invalid?: boolean;
    disabled?: boolean;
    /** No field chrome: text that sits inline in a card or a composer box, which supplies the frame. */
    bare?: boolean;
  }>(),
  { rows: 4, invalid: false, disabled: false, bare: false },
);

const model = defineModel<string>();
const attrs = useAttrs();
const controlId = useFieldControlId(() => attrs.id as string | undefined);
</script>

<template>
  <textarea
    v-model="model"
    v-bind="$attrs"
    :id="controlId"
    :rows="rows"
    :placeholder="placeholder"
    :disabled="disabled"
    class="lumi-textarea"
    :class="{ 'lumi-textarea--invalid': invalid, 'lumi-textarea--bare': bare }"
  />
</template>

<style>
.lumi-textarea{display:block;width:100%;padding:9px 12px;border:1px solid var(--field-border);border-radius:var(--radius-md);background:var(--field-bg);color:var(--text-heading);font-family:var(--font-body);font-size:var(--text-sm);line-height:1.5;transition:border-color var(--dur-fast);resize:vertical;}
.lumi-textarea::placeholder{color:var(--text-tertiary);}
.lumi-textarea:focus{border-color:var(--panel-edge);}
.lumi-textarea:disabled{background:var(--surface-wash);color:var(--text-secondary);cursor:not-allowed;}
.lumi-textarea--bare{padding:0;border:0;border-radius:0;background:transparent;resize:none;}
.lumi-textarea--bare:focus,.lumi-textarea--bare:focus-visible{outline:none;}
.lumi-textarea--bare:disabled{background:transparent;}
.lumi-textarea--invalid{border-color:var(--danger);}
.lumi-textarea--invalid:focus{border-color:var(--danger);}
.lumi-textarea--invalid:focus-visible{outline-color:var(--danger);}
</style>
